module.exports = __webpack_public_path__ + "img/live.30c884d6.svg";